<div class="cq-accordion">
  <div class="accordion-container">
    <div class="title" *ngIf="isShowTitle" [innerHtml]="title"></div>
    <div class="accordion-content">
      <div *ngFor="let item of items; let i = index" class="accordion-item">
        <div
          [ngClass]="{ 'header-active': activeIndexes.indexOf(item.id) > -1, 'accordion-item-header': true }"
          (click)="toggle(item.id)"
        >
          <div class="accordion-item-text" [innerHtml]="item?.htmlItemHeader"></div>
          <div class="icon" [ngClass]="{ open: activeIndexes.indexOf(item.id) > -1 }">
            @if (activeIndexes.indexOf(item.id) > -1) {
              <img src="/assets/icons/arrow-down.svg" alt="arrow-down" />
            } @else {
              <img src="/assets/icons/arrow-up.svg" alt="arrow-up" />
            }
          </div>
        </div>
        <div class="accordion-item-content" [style.display]="activeIndexes.indexOf(item.id) > -1 ? 'block' : 'none'">
          <div *ngIf="item.htmlItemContent" [innerHtml]="item?.htmlItemContent"></div>
        </div>
      </div>
    </div>
  </div>
</div>
